import URI from 'urijs';
import {
    APPLICATION_ID_PARAM_NAME,
    CONNECT_LOGIN_LOCATION,
    CONNECT_SDK_LOCATION,
    GENOME_ID_PARAM_NAME,
    AUTH_URL,
} from './constants';
import { getEnvDependentEndpoint } from '@sitegen/common/utils/ubi-services';
import { delay } from '@sitegen/common/utils/timer';
import { IWindowWithConnect } from './types';

export function transitionNextUrl(applicationId: string, genomeId: string, topicOfPostMessage: string) {
    if (window.opener) {
        window.opener.postMessage(
            {
                topic: topicOfPostMessage,
                applicationId: applicationId,
                genomeId: genomeId,
                payload: ''
            },
            '*'
        );
    }
    if (window.parent.parent) {
        window.parent.parent.postMessage(
            {
                topic: topicOfPostMessage,
                applicationId: applicationId,
                genomeId: genomeId,
                payload: ''
            },
            '*'
        );
    }
    if (window.parent) {
        window.parent.postMessage(
            {
                topic: topicOfPostMessage,
                applicationId: applicationId,
                genomeId: genomeId,
                payload: ''
            },
            '*'
        );
    }
}

// SUCCESS_NEXT_URL: should be the function,
// because window location href can be changed by router (which invoke re-render), so we need to recalculate this value
export const SUCCESS_NEXT_URL = (applicationId: string, genomeId: string) => {
    return new URI('')
        .segment([AUTH_URL])
        .search({
            [APPLICATION_ID_PARAM_NAME]: applicationId,
            [GENOME_ID_PARAM_NAME]: genomeId,
        })
        .href();
};

export const calculatePopupSize = (align?: string) => {
    const defaultPopupWidth = 400;
    const defaultPopupHeight = 600;

    if (align === 'center') {
        // handle case when several monitors
        const dualScreenLeft = typeof window.screenLeft !== 'undefined' ? window.screenLeft : window.screenX;
        const dualScreenTop = typeof window.screenTop !== 'undefined' ? window.screenTop : window.screenY;
        const width = window.innerWidth
            ? window.innerWidth
            : document.documentElement!.clientWidth
                ? document.documentElement!.clientWidth
                : screen.width;
        const height = window.innerHeight
            ? window.innerHeight
            : document.documentElement!.clientHeight
                ? document.documentElement!.clientHeight
                : screen.height;
        const top = height / 2 - defaultPopupHeight / 2 + dualScreenTop;
        const left = width / 2 - defaultPopupWidth / 2 + dualScreenLeft;

        return {
            top,
            left,
            width: defaultPopupWidth,
            height: defaultPopupHeight
        };
    } else {
        return {
            top: 0,
            left: 0,
            width: defaultPopupWidth,
            height: defaultPopupHeight
        };
    }
};

export const getConnectEndpoint = (envName: string): string => {
    return getEnvDependentEndpoint({ envName, source: CONNECT_LOGIN_LOCATION });
};

export const getSDKEndpoint = (envName: string): string => {
    return getEnvDependentEndpoint({ envName, source: CONNECT_SDK_LOCATION });
};

export const isSafari = typeof navigator !== 'undefined' && /.*Version.*Safari.*/.test(navigator.userAgent);

export const fallbackConnectInit = (subscriber: Function, maxAttempts: number = 10) => {
    async function reserve(value: number = 0) {
        const overlayConnectSDK = (window as IWindowWithConnect).overlayConnectSDK;

        if (value === maxAttempts) {
            return Promise.reject('Connect couldn\'t be initialized!');
        }

        if (overlayConnectSDK) {
            return subscriber(overlayConnectSDK);
        }

        await delay(1000);

        reserve(++value);
    };

    return reserve();
};
